var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFoodTray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_184_8485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 55.25H55.25",
    stroke: "#010101",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0111 39.3088C65.8686 28.9463 63.0274 14.9851 52.6649 8.12759C42.3024 1.27009 28.3424 4.11009 21.4849 14.4738L59.0111 39.3088Z",
    stroke: "#010101",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8612 7.0701C56.7187 8.7976 54.3925 9.2701 52.6651 8.1276C50.9375 6.9851 50.465 4.6576 51.6076 2.93135C52.75 1.20385 55.0775 0.730098 56.8037 1.87385C58.5312 3.01635 59.005 5.3426 57.8612 7.0701Z",
    stroke: "#010101",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 37.9744C19 34.735 21.2467 32 24.5055 32C28.6885 32 29.9236 36.8813 29.9236 36.8813C29.9236 36.8813 31.3302 32 35.5134 32C38.772 32 41.0174 34.735 41.0174 37.9744C41.0174 42.4222 36.5976 43.965 29.9236 49.75C23.3946 44.0922 19 42.4562 19 37.9744Z",
    stroke: "#EB731A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 55.25H55.25C53.1788 55.25 51.5 56.9288 51.5 59C51.5 61.0712 49.8212 62.75 47.75 62.75H24",
    stroke: "#010101",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 62.75H12.5C10.4288 62.75 8.75 61.0712 8.75 59C8.75 56.9288 7.07125 55.25 5 55.25H1.25",
    stroke: "#010101",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_184_8485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodTray);
export default __webpack_public_path__ + "static/media/food-tray.1aaab6cd57fb0188350375078ff24215.svg";
export { ForwardRef as ReactComponent };